import React, { ReactElement } from "react";

import { YesOrNo } from "Components/InsuranceDetailsCard/ProductDetailsTable/ProductDetailsLists/Boolean";
import { Owner } from "Store/interfaces/Owner";
import { useOwnerTexts } from "Store/texts/hooks";
import { getAgeFromDate } from "Validation/dateValidaton";
import { ProductOwnerAge } from "../../styled";

interface Props {
  readonly isOwner: boolean;
  readonly owner: Owner;
}

export const ProductOwner = ({
  isOwner,
  owner,
}: Props): ReactElement<Props> => {
  const [ownerTexts, lang] = useOwnerTexts();
  if (!isOwner) {
    return (
      <>
        <YesOrNo value={true} />
        {owner.relation && `, ${ownerTexts[owner.relation][lang]}`}
        {owner.dateOfBirth && (
          <ProductOwnerAge>
            {`, ${getAgeFromDate(new Date(owner.dateOfBirth))} ${
              ownerTexts.year[lang]
            }`}
          </ProductOwnerAge>
        )}
      </>
    );
  }
  return <YesOrNo value={false} />;
};
